import { useCan } from '@features/user';

import { useReportDefinitions } from '../store/hooks';

/**
 * Whether the current user can see the reports console at all.
 *
 * Report access is per-report (each definition's default roles ± the org's
 * overrides), resolved by the backend: the definitions endpoint returns only
 * the reports this user may run. Console/nav visibility derives from that —
 * report managers always have access; everyone else has access iff at least
 * one report is visible to their roles.
 */
export const useReportsAccess = (): { hasAccess: boolean; isLoading: boolean } => {
  const canManageReports = useCan('manage_reports');
  const { data, isLoading } = useReportDefinitions(undefined, {
    skip: canManageReports,
  });
  if (canManageReports) return { hasAccess: true, isLoading: false };
  return {
    hasAccess: (data?.reports?.length ?? 0) > 0,
    isLoading,
  };
};
